import { initClient } from 'rwsdk/client';

void initClient();
